import Blog_50_9_container from "./container/Blog_50_9_container";
export default Blog_50_9_container;
